export default __webpack_public_path__ + "static/media/music-solid.72caa7bb.svg";